import React from 'react';

import { HeaderTab, HeaderTabBar } from './header-tab-bar';

const t = require('views/internal/recup-with-helpers')('home');

interface TeamCardsProps extends React.HTMLAttributes<HTMLDivElement> {
  orgname: string;
  cardsTabName: string;
}

export const TeamCards: React.StatelessComponent<TeamCardsProps> = ({
  cardsTabName,
  children,
  orgname,
  ...props
}) => (
  <div {...props}>
    <HeaderTabBar>
      <HeaderTab
        isActive={cardsTabName === 'due'}
        iconName="calendar"
        url={cardsTabName !== 'due' ? `/${orgname}/cards/due` : undefined}
      >
        {t.l('due-dates')}
      </HeaderTab>
      <HeaderTab
        isActive={cardsTabName === 'assigned'}
        iconName="card"
        url={
          cardsTabName !== 'assigned' ? `/${orgname}/cards/assigned` : undefined
        }
      >
        {t.l('assigned')}
      </HeaderTab>
    </HeaderTabBar>
    {children}
  </div>
);



// WEBPACK FOOTER //
// ./app/scripts/views/home/presentational/team-cards.tsx